import constants from '../../../constants'

const PreHeaderLogoIcon = () => {
  // Show Sweet Sweat Logo on Sports Research and SR on SS
  return constants.BRAND === 'sports-research' ? (
    <svg
      width="13"
      height="21"
      viewBox="0 0 13 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33194 8.19357C8.55872 7.16033 7.81045 5.92542 7.81876 4.59105C7.82708 3.4777 8.59198 2.21792 9.55365 1.63776C9.79754 1.49134 10.0747 1.39188 10.3019 1.22889C10.4183 1.14601 10.5652 0.933281 10.4377 0.761996C10.374 0.676353 10.2714 0.681878 10.18 0.6211C9.54534 0.604524 9.09637 0.800673 8.66127 0.983009C7.82708 1.33111 7.12869 1.76484 6.43029 2.2345C5.57948 2.80637 4.79517 3.46665 4.08847 4.20704C2.50046 5.87845 1.2949 7.88968 0.535542 10.0611C0.130918 11.2132 -0.0353654 12.4729 0.00620548 13.6885C0.031148 14.4096 0.158632 15.1665 0.380344 15.8517C0.593741 16.512 0.926308 17.1253 1.28382 17.7192C2.409 19.5813 4.30741 20.6007 6.48849 20.62C6.99843 20.6228 7.51668 20.5455 8.00722 20.4101C10.0719 19.8354 11.5906 18.3132 12.2197 16.2827C12.871 14.1803 12.0673 11.6856 10.8036 9.9672C10.349 9.35113 9.79199 8.80688 9.33194 8.19081"
        fill="#212721"
      />
    </svg>
  ) : (
    <svg
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64547 0.00695801H3.59315C1.67845 0.00695801 0.128246 1.61142 0.128246 3.58794C0.128246 5.56445 1.6807 7.17124 3.59315 7.17124H4.86886M4.53137 19.9977L0.0112497 14.3355H0.00224993V14.3239H0V14.3146L4.86661 7.17357H5.30985C7.22454 7.17357 8.777 8.77803 8.777 10.7545C8.777 12.6311 7.38204 14.1681 5.60459 14.3239H5.69009L10.2192 20H4.53137V19.9977Z"
        fill="white"
      />
    </svg>
  )
}

export default PreHeaderLogoIcon
